(function ($) {
    class RLM_HeaderSlider {
        constructor () {
            if (!$('.header-slider-wrapper').length) {
                return;
            }
            
            this.initState();        
            this.initEvents();
        }
    
        initState () {
            this.prevItem = 0;
            this.currentItem = 0;
            this.win = $(window);
            this.wrapper = $('.header-slider-wrapper');
            this.slides = this.wrapper.find('.slider-slide');
            this.slidesWrapper = this.wrapper.find('.header-slider-slides');
            this.dots = this.wrapper.find('.dot');
            this.count = parseInt(this.wrapper.attr('data-count'), 10);
            this.buttons = this.wrapper.find('.slider-buttons');
            this.blankSlide = false;
            this.interval = 3500;
            this.videoWrapper = this.wrapper.find('.slider-video-wrapper');
            this.videoContainer = this.videoWrapper.find('.slider-video-inner-wrapper');
            this.animationInProgress = false;
            this.swipeEffect = new Hammer(this.wrapper[0]);
            this.menuBar = $('.menu-top-bar');
            let ua = navigator.userAgent.toLowerCase();
            this.isAndroid = ua.indexOf("android") > -1;
        }
    
        initEvents () {
            let self = this;

            this.dots.on('click', function() {
                let index = parseInt($(this).attr('data-index'), 10);
                self.blankSlide = true;
                self.setItem(index);
            });

            this.buttons.find('.btn-outline').each((i, btn) => {
                $(btn).on('click', e => {
                    e.preventDefault();
                    this.wrapper.addClass('is-expanded');
                    this.wrapper.parent().addClass('is-expanded');
                    this.menuBar.addClass('has-video-visible');
                    this.videoWrapper.addClass('is-visible');
                    this.videoContainer.html('<video src="' + $(btn).attr('href') + '" autoplay playsinline></video>');

                    $('html, body').animate({
                        scrollTop: 0
                    }, 250);

                    if (this.isAndroid && screen.orientation.type.indexOf('landscape') > -1) {
                        let videoElement = this.videoContainer.find('video')[0];

                        if (!videoElement) {
                            return;
                        }

                        if (videoElement.requestFullscreen) {
                            videoElement.requestFullscreen();
                        } else if (videoElement.mozRequestFullScreen) {
                            videoElement.mozRequestFullScreen();
                        } else if (videoElement.webkitRequestFullscreen) {
                            videoElement.webkitRequestFullscreen();
                        } else if (vidoeElement.msRequestFullscreen) {
                            videoElement.msRequestFullscreen();
                        }
                    }
                });
            });

            this.videoContainer.on('click', e => {
                if (e.target.tagName === 'VIDEO') {
                    if (!e.target.paused) {
                        e.target.pause();
                    } else {
                        if (this.isAndroid) {
                            if (e.target.requestFullscreen) {
                                e.target.requestFullscreen();
                            } else if (e.target.mozRequestFullScreen) {
                                e.target.mozRequestFullScreen();
                            } else if (e.target.webkitRequestFullscreen) {
                                e.target.webkitRequestFullscreen();
                            } else if (e.target.msRequestFullscreen) {
                                e.target.msRequestFullscreen();
                            }
                        }

                        e.target.play();
                    }
                }
            });

            this.videoWrapper.find('.slider-video-close').on('click', e => {
                e.preventDefault();
                this.wrapper.removeClass('is-expanded');
                this.wrapper.parent().removeClass('is-expanded');
                this.videoWrapper.removeClass('is-visible');

                setTimeout(() => {
                    this.menuBar.removeClass('has-video-visible');
                }, 200);
            
                setTimeout(() => {
                    this.videoContainer.html('');
                }, 1000);
            });

            setTimeout(() => {
                this.autoAnimate();
            }, this.interval);

            this.swipeEffect.on('swipe', ev => {
                if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 2) && ev.deltaX < -100) {
                    let itemIndex = this.currentItem;
                    itemIndex++;
    
                    if (itemIndex >= this.slides.length) {
                        itemIndex = 0;
                    }
                    
                    this.dots.eq(itemIndex).trigger('click');
                }
    
                if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 4) && ev.deltaX > 100) {
                    let itemIndex = this.currentItem;
                    itemIndex--;
    
                    if (itemIndex < 0) {
                        itemIndex = this.slides.length - 1;
                    }
                    
                    this.dots.eq(itemIndex).trigger('click');
                }
            });

            if (this.isAndroid) {
                $(window).on('orientationchange', e => {
                    let videoElement = this.videoContainer.find('video')[0];

                    if (!videoElement || videoElement.paused) {
                        return;
                    }

                    if (screen.orientation.type.indexOf('landscape') === -1) {
                        return;
                    }

                    if (videoElement.requestFullscreen) {
                        videoElement.requestFullscreen();
                    } else if (videoElement.mozRequestFullScreen) {
                        videoElement.mozRequestFullScreen();
                    } else if (videoElement.webkitRequestFullscreen) {
                        videoElement.webkitRequestFullscreen();
                    } else if (vidoeElement.msRequestFullscreen) {
                        videoElement.msRequestFullscreen();
                    }
                });
            }
        }

        autoAnimate () {
            if (this.blankSlide) {
                this.blankSlide = false;
            } else {
                let nextIndex = this.currentItem + 1;
                this.setItem(nextIndex);
            }

            setTimeout (() => {
                this.autoAnimate();
            }, this.interval); 
        }
    
        setItem (index) {
            if (this.animationInProgress) {
                return;
            }

            this.animationInProgress = true;
            this.prevItem = this.currentItem;
            this.currentItem = index;

            if (this.currentItem >= this.count) {
                this.currentItem = 0;
            }

            this.setActiveSlide();
            this.setActiveText();
            this.setActiveDot();
        }

        nextItem () {
            let nextIndex = this.currentItem;
            nextIndex++;
            this.setItem(nextIndex);
        }

        setActiveSlide () {
            this.slidesWrapper.attr('data-current-slide', this.currentItem);

            setTimeout(() => {
                this.animationInProgress = false;
            }, 1000);
        }

        setActiveText () {
            this.buttons.attr('data-current-slide', this.currentItem);
        }

        setActiveDot () {
            this.dots.removeClass('is-active');
            this.dots.eq(this.currentItem).addClass('is-active');
        }
    }
    
    new RLM_HeaderSlider();
})(jQuery);